import moment from 'moment';
import ConfirmModal from '@/components/shared/ConfirmModal';
import Co2Items from '@/internalData/Co2Items';
import { configDatePick } from '@/services/GlobalServices';
import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardInternalConstant from "@/internalData/Dashboard"
import TrashIcon from "@/components/shared/TrashIcon"
import GlobalConstants from "@/store/constants/global"
import Co2ModalHelper from "@/helper/dashboard/co2ModalHelper"
export default {
  name: "Co2Modal",
  components: {
    ConfirmModal,
    TrashIcon
  },
  data() {
    return {
      dataTimePickerOptions: configDatePick("LT"),
      machineTypeOption: DashboardInternalConstant.co2Modal.machineTypeOption,
      inSiteWorkFields: DashboardInternalConstant.co2Modal.inSiteWorkFields,
      outSiteWorkFields: DashboardInternalConstant.co2Modal.outSiteWorkFields,
      loadCapacityRecords: DashboardInternalConstant.co2Modal.loadCapacityRecords,
    };
  },
  updated() {
    this.$nextTick(() => {
      this.setHeightMachineOwner();
    });
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent) => {
      if (bvEvent.componentId == "co2-modal") {
        setTimeout(() => {
          //make sure ID appeared
          this.setHeightMachineOwner();
        }, 100);
      }
    });
  },
  methods: {
    getHeaderColspan(index) {
      return (index <= 1 || index == 4) ? 2 : 1
    },
    showConfirmModal(attr, orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: attr, orderId: orderId });
    },
    addNewLineInSiteWork() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, 'co2InSiteWork');
    },
    addNewLineOutSiteWork() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, 'co2OutSiteWork');
    },
    setTimeCo2Input(index, attr, value){
      const formatValue = value.date ? value.date : null
      const objectInput = Co2ModalHelper.generateCo2InputObject(index, attr, formatValue)
      if(Co2ModalHelper.validateInputTime(attr, value.date)){
        const defaultStartDate = moment("01/01/2000", "DD/MM/YYYY");
        defaultStartDate.set("hour", value.date.format("HH"));
        defaultStartDate.set("minute", value.date.format("mm"));
        objectInput.value = defaultStartDate.toISOString(true);
      }
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, objectInput);
    },
    setMachineLayerCo2Input(index, attr, value){
      if(Co2ModalHelper.validateMachineLayer(attr)){
        this.resetDataMachineLayer(attr, index)
        const objectInput = Co2ModalHelper.generateCo2InputObject(index, attr, value.key)
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, objectInput);
      }
    },
    resetDataMachineLayer(attr, index){
      if(attr == "oldMachineFirstLayer"){
        this.resetMachineLayerSecondAndThird(index)
      }else if(attr == "oldMachineSecondLayer"){
        this.resetMachineLayerThird(index)
      }
    },
    resetMachineLayerSecondAndThird(index){
      this.resetDataInSiteWork("oldMachineSecondLayer", index);
      this.resetDataInSiteWork("oldMachineThirdLayer", index);
    },
    resetMachineLayerThird(index){
      this.resetDataInSiteWork("oldMachineThirdLayer", index);
    },
    resetDataInSiteWork(attr, index){
      const path = ["co2InSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: '' });
    },
    setInputCo2InSiteWork(attr, value, index) {
      // add value machineOwner
      const path = ["co2InSiteWork", index, attr].join(".");
      let obj_input = { path: path, value: value };
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, obj_input);
    },
    setInputCo2OutSiteWork(attr, value, index) {
      const path = ["co2OutSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: value });
    },
    handleOutFocusInSiteWork(attr, index) {
      this.existErrors() && this.resetDataInSiteWork(attr, index);
    },
    existErrors(){
      return this.errors.all().length!=0
    },
    resetDataOutSiteWork(index, attr){
      const path = ["co2OutSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: '' });
    },
    handleOutFocusOutSiteWork(attr, index) {
      this.existErrors() && this.resetDataOutSiteWork(index, attr)
    },
    getValueInSiteWorkAt(index) {
      return this.co2InSiteWork[index];
    },
    disableSecondLayer(valueFirstLayer) {
      return this.statusEditable || valueFirstLayer == '';
    },
    disableThirdLayer(index) {
      const valueSecondLayer = this.getValueInSiteWorkAt(index).oldMachineSecondLayer == null;
      const valueThirdLayer = this.getValueInSiteWorkAt(index).oldMachineSecondLayer == '';
      return (this.statusEditable || valueSecondLayer || valueThirdLayer);
    },
    secondLayer(item) {
      const firstLayerFields = this.firstLayer;
      return firstLayerFields[item.oldMachineFirstLayer].items;
    },
    thirdLayer(item) {
      const firstLayerFields = this.firstLayer;
      return firstLayerFields[item.oldMachineFirstLayer].items[item.oldMachineSecondLayer].items;
    },
    isShowThirdLayer(item) {
      const isFirstItemNull = item.oldMachineFirstLayer != '';
      const isSecondItemNull = item.oldMachineSecondLayer != '';
      return isFirstItemNull && isSecondItemNull;
    },
    getNameFirstLayer(key) {
      const regx = /^99[0-9]+/
      const co2Items = Co2Items.CO2_ITEMS
      const co2NewItems = Co2Items.NEW_CO2_ITEMS
      if (regx.test(key)) {
        return key != "" ? co2NewItems[key].name : "";
      } else {
        return key != "" ? co2Items[key].name : "";
      }
    },
    getNameSecondLayer(itemFirstLayer, key) {
      let co2Items = Co2Items.CO2_ITEMS;
      let co2NewItems = Co2Items.NEW_CO2_ITEMS
      if (itemFirstLayer != "" && key != "") {
        return co2Items[itemFirstLayer] ? co2Items[itemFirstLayer].items[key].name : co2NewItems[itemFirstLayer].items[key].name
      } else {
        return ""
      }
    },
    getNameThirdLayer(keyFirstItem, keySecondItem, keyThirdItem) {
      let items = Co2Items.CO2_ITEMS;
      let newItems = Co2Items.NEW_CO2_ITEMS
      if (keyFirstItem != "" && keySecondItem != "" && keyThirdItem != "") {
        if (items[keyFirstItem]) {
          return items[keyFirstItem].items[keySecondItem].items[keyThirdItem].name;
        } else {
          return newItems[keyFirstItem].items[keySecondItem].items[keyThirdItem].name;
        }
      }
      return "";
    },
    getSecondLayer(keyFirstItem) {
      const firstLayer = this.firstMachineLayer;
      for (let firstItem of firstLayer) {
        if (firstItem.key == keyFirstItem) {
          return firstItem.items;
        }
      }
      return firstLayer[1].items;
    },
    getThirdLayer(keyFirstItem, keySecondItem) {
      const secondLayer = this.getSecondLayer(keyFirstItem);
      for (let secondItem of secondLayer) {
        if (secondItem.key == keySecondItem) {
          return secondItem.items;
        }
      }
      return secondLayer.items;
    },
    addClassHeaderInSiteWork(index) {
      if (index == 3) {
        return "in-site-work-th-number";
      }else if(index == 5) {
        return "in-site-work-th-total-operation-time";
      }
    },
    setHeightMachineOwner() {
      const inSiteWorks = this.co2InSiteWork;
      if (inSiteWorks) {
        for (let inSiteWorkIndex in inSiteWorks) {
          // const inSiteWork = inSiteWorks[inSiteWorkIndex]
          const idNameLayerMachine = `tr_type_machine_layer_${inSiteWorkIndex}`;
          const idMachineOwnerTo = `textarea_machine_owner_${inSiteWorkIndex}`;
          const idBudgetTitle = `p_budget_title_${inSiteWorkIndex}`;
          const idActualTitle = `p_actual_title_${inSiteWorkIndex}`;
          const idTotalTime = `p_total_time_${inSiteWorkIndex}`;
          const machineLayer = document.getElementById(idNameLayerMachine);
          const textareaMachine = document.getElementById(idMachineOwnerTo);
          const pBudgetTitle = document.getElementById(idBudgetTitle);
          const pActualTitle = document.getElementById(idActualTitle);
          const pTotalTime = document.getElementById(idTotalTime);

          if (machineLayer && textareaMachine) {
            const heightMachineLayer = machineLayer.offsetHeight
            const halfHeightMachineLayer = heightMachineLayer/2;
            textareaMachine.style.height = `${heightMachineLayer}px`;
            pTotalTime.style.lineHeight = `${heightMachineLayer}px`;
            pBudgetTitle.style.height = `${halfHeightMachineLayer}px`;
            pBudgetTitle.style.lineHeight = `${halfHeightMachineLayer}px`;
            pActualTitle.style.height = `${halfHeightMachineLayer}px`;
            pActualTitle.style.lineHeight = `${halfHeightMachineLayer}px`;
          }
        }
      }
    }
  },
  filters: {
    formatMMHH(dt) {
      return moment(dt).format("HH:mm");
    },
    getDiffDay(actual_dt, unit) {
      const millisecondIn24Hours = 24*1000*60*60
      if(!Co2ModalHelper.validateDifferentActualTime(actual_dt, unit)){
        return "-"
      }
      let diff_time_actual = moment(actual_dt.to).diff(moment(actual_dt.from));
      if (diff_time_actual < 0) {
        diff_time_actual = millisecondIn24Hours + diff_time_actual;
      }
      diff_time_actual *= unit;
      let hours = parseInt(diff_time_actual / 1000 / 60 / 60);
      let minutes = parseInt(diff_time_actual / 1000 / 60 % 60);
      if (hours <= 9) {
        hours = "0" + hours;
      }
      if (minutes <= 9) {
        minutes = "0" + minutes;
      }
      return `${hours}:${minutes}`;
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    co2InSiteWork() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].co2InSiteWork;
    },
    co2OutSiteWork() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].co2OutSiteWork;
    },
    firstLayer() {
      let items = Co2Items.CO2_ITEMS;
      return items;
    },
    firstMachineLayer() {
      let co2ItemArr = Co2Items.DATA_AFTER_CONVERT;
      return co2ItemArr;
    }
  },
};